import "./BatteryService.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import LixrForBusiness from "./sections/LixrForBusiness";
import Footer from "@/reusable_sections/Footer";
export default function BatteryServicePage() {
  return <div>
      <Header />
      <OurStory />
      <LixrForBusiness />
      <Footer />
    </div>;
}